import { render, staticRenderFns } from "./category_config.vue?vue&type=template&id=2a921e81&"
import script from "./category_config.vue?vue&type=script&lang=js&"
export * from "./category_config.vue?vue&type=script&lang=js&"
import style0 from "./category_config.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports